/**
 * RevenueCat entitlement that marks an account as subscribed. It started life
 * as "cross-device sync" (the `sync` lookup key is baked into the database's
 * `has_sync_access`, the webhook and the dashboard, so it stays), and now also
 * gates the whole web app: there is no local-only mode on web. Native apps keep
 * local use free and gate only sync behind it. See go-live.md for the
 * dashboard project this mirrors.
 */
export const DURANCE_SYNC_ENTITLEMENT = "sync";

/** Current offering lookup key in the RevenueCat dashboard. */
export const DURANCE_DEFAULT_OFFERING = "default";

/**
 * Store product identifier for the monthly subscription: US$4.99/month with a
 * 14-day free trial. The same identifier is used on the Web Billing and Test
 * Store apps in RevenueCat, and should be reused for the App Store / Play
 * Store products once they exist.
 */
export const DURANCE_MONTHLY_PRODUCT_ID = "durance_monthly";

/**
 * Display fallbacks for copy shown before (or without) a RevenueCat package.
 * The live price/trial always come from the package itself when available —
 * these only exist so static text (sign-in screens, store copy) stays
 * consistent with the dashboard. Keep in sync with `durance_monthly`.
 */
export const DURANCE_MONTHLY_PRICE_TEXT = "$4.99";
export const DURANCE_TRIAL_DAYS = 14;
